<template>
  <div>
    <!-- 增值电信业务经营许可 -->
    <img style="width: 100%" src="https://cdn.mekoom.com/assets-v3/certificate/增值电信业务经营许可.jpg" alt="">
  </div>
</template>
<script>
  export default {};
</script>
<style scoped>

</style>
